import essApi from "../axios/essApi";

class UserAllocationService {
  async createUserAllocation() {
    return Promise.resolve(essApi.post(`allocation-by-user`));
  }

  /* get Employee Timesheet Action Start */
  async getEmpAction() {
    return Promise.resolve(essApi.get(`timesheet-actions`));
  }
  /* get Employee Timesheet Action end */

  /*get My Action start*/
  async getMyAction() {
    return Promise.resolve(essApi.get(`my-action`));
  }
  /*get My Action end*/

  /*send allocation reminder from my action start*/
  async updateAllocApprovalAction(body) {
    return Promise.resolve(essApi.put(`allocation-reminder`), body);
  }
  /*send allocation reminder from my action end*/

  /*send timesheet reminder from my action start*/
  async updateTimesheetApprovalAction(body) {
    return Promise.resolve(essApi.put(`timesheet-reminder`,body));
  }
  /*send timesheet reminder from my action start*/
}

export default UserAllocationService;
